var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{ref:"text",tag:"component",staticClass:"fadeLink",class:_vm.color,on:{"mouseenter":_vm.animateIn,"mouseleave":_vm.animateOut}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }